import { useStore } from './useStore'

const useLogTransaction = () => {
  const { state } = useStore()
  const actionCodePrefix = 'BSS'
  const userTypeCode = state.form?.IsAgent ? 'A' : 'B'

  const getWebActionCode = (type, overrides = {}) => {
    const isMortgage = overrides.IsMortgage ?? state.borrower?.IsMortgage
    let agentCode = userTypeCode
    if (overrides.IsAgent != null) agentCode = overrides.IsAgent ? 'A' : 'B'
    let actionCode = ''
    switch (type) {
      case 'attach':
        actionCode = `${actionCodePrefix}Att`
        actionCode = `${actionCode}${isMortgage ? 'Non' : 'Std'}${agentCode}`
        break
      case 'insurance':
        actionCode = `${actionCodePrefix}SubIns${agentCode}`
        break
      default:
        actionCode = `${actionCodePrefix}Att`
        break
    }
    return actionCode
  }
  const getContractCode = (overrides = {}) => {
    const isVehicle = overrides.IsVehicle ?? state.borrower?.IsVehicle
    const isMortgage = overrides.IsMortgage ?? state.borrower?.IsMortgage
    if (isVehicle) return '3'
    if (isMortgage) return '2'
    return '0'
  }

  const getAdditionalInfo = (data, overrides = {}) => {
    const additonalInfo = []
    const email =
      overrides.PolicyholderEmailAddress ?? state.form?.PolicyholderEmailAddress
    if (email) additonalInfo.push('Email:' + email)
    if (data.files && data.files.length > 0)
      additonalInfo.push('Files:' + data.files.join(','))
    return additonalInfo.join(';')
  }

  const getLogRequest = async (data, overrides = {}) => {
    const base = {
      LenderCode: overrides.LenderCode ?? state.borrower?.LenderCode ?? null,
      UserType:
        overrides.IsAgent ?? state.borrower?.IsAgent ? 'Agent' : 'Borrower',
      WebActionCode: getWebActionCode(data.type, overrides),
      ContractCode: overrides.ContractCode ?? getContractCode(overrides),
      LoanNumber: overrides.LoanNumber ?? state.borrower?.LoanNumber ?? null,
      LockId: 1,
      LoanId: overrides.LoanId ?? state.borrower?.LoanID ?? null,
      ReferenceId: overrides.ReferenceId ?? state.borrower?.ReferenceID ?? null,
      CoverageId:
        overrides.CoverageId ?? state.borrower?.RequiredCoverageID ?? null,
      CollateralId:
        overrides.CollateralId ?? state.borrower?.CollateralID ?? null,
      PropertyId: overrides.PropertyId ?? state.borrower?.PropertyID ?? null,
      Status: 'Success',
      AddlInfo: getAdditionalInfo(data, overrides),
    }
    return { ...base, ...overrides }
  }
  const LogTransaction = async (data, requestOverrides = {}) => {
    const logRequest = await getLogRequest(data, requestOverrides)
    await fetch(`${process.env.GATSBY_API_URL}/log-webusage`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(logRequest),
    })
      .then(response => response.json())
      .then(data => {
        console.log('Success:', data)
      })
      .catch(error => {
        console.error('Error:', error)
      })
  }

  return {
    LogTransaction,
  }
}

export { useLogTransaction }
